export const NO_WRAP_FIELDS = ['cpf', 'company_cnpj', 'phone', 'company_phone'];
export const CLOSE_TO_COLON_FIELDS = ['cpf', 'company_email'];
export const TEXT_LIMIT_FIELDS = ['company_description', 'company_motivation'];
export const READONLY_FIELDS = ['cpf', 'company_cnpj'];
export const MAX_TEXT_LENGTH = 512;
export const API_DELAY_MS = 500;
export const CEP_DEBOUNCE_MS = 800;

export const SOCIAL_MEDIA_OPTIONS = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'google', label: 'Google' }
] as const;

